<HomeNavBar />
<InactivityModal />


<div class="container-fluid py-3">

<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
  <h4 class="mb-0">Personal Profiles</h4>

  <!-- Desktop version: natural width -->
  <div class="position-relative d-none d-md-block mt-0">
    <i class="bi bi-search text-muted position-absolute top-50 start-0 translate-middle-y ms-3"></i>
    <input
      type="text"
      class="form-control form-control-sm ps-5 shadow-sm rounded"
      placeholder="Search here"
      v-model="userSearch"
    >
  </div>

  <!-- Mobile version: full width -->
  <div class="position-relative d-block d-md-none w-100 mt-2">
    <i class="bi bi-search text-muted position-absolute top-50 start-0 translate-middle-y ms-3"></i>
    <input
      type="text"
      class="form-control form-control-sm ps-5 shadow-sm rounded w-100"
      placeholder="Search here"
      v-model="userSearch"
    >
  </div>
</div>




      <!-- <div class="row mt-3 overflow-auto p-4 full-width-mobile mt-2 mb-5"> -->
        <div v-if="loading" class="text-center py-5 w-100">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2 mb-0 text-muted">Loading profiles...</p>
        </div>

         <div v-else class="row full-width-mobile scrollable-container">
          <div v-for="user in filteredUsers" :key="user.id" class="col-12 col-sm-4 col-lg-4 col-xl-2 mb-2">
                <div class="team-card">
  <div class="d-flex align-items-center gap-2 p-1">

    <!-- IMAGE -->
    <img
      v-if="user.profile_picture"
      :src="user.profile_picture"
      alt="profile picture"
      class="avatar-person"
    />
    <img
      v-else
      src="@/assets/images/user.png"
      alt="Profile"
      class="avatar-person"
    />

    <!-- TEXT (STACKED LEFT) -->
    <div class="d-flex flex-column text-start">
      <div class="mb-1 text-xxs fw-500">
        {{ user.first_name }} {{ user.last_name }}
      </div>
    </div>

  </div>

  <!-- BUTTON -->
  <a
    @click="view_profile(user)"
    class="btn btn-primary btn-sm w-100 text-xxs rounded"
  >
    View Profile
  </a>
</div>
            </div>
        </div>
        <!-- Empty State -->
        <div v-if="!loading && !filteredUsers.length" class="text-center text-muted py-5 w-100">
          <i class="bx bx-user fs-1"></i>
          <p class="mt-2 mb-0">No users found</p>
        </div>
      <!-- </div> -->

      </div>
<StickyNav />
